import axios from "axios";
import { useDispatch } from "react-redux";
import { receiptsActions } from "../../redux/slices/recieptsSlice";
import { APIConstants } from "../../constants/ApiConstants";
import { useAppSelector } from "../../redux/hooks";
import { useEffect, useState } from "react";
import formatDate from "../../util/dateFormat";
import { getFeaturePermissions } from "../../util/permissions";
import { filterConstants } from "../../constants/AppConstants";

export const useListReceipts = () => {
  const dispatch = useDispatch();
  const receiptsList = useAppSelector(
    (state: any) => state.persistReducers.getReceiptsList?.receiptsList
  );
  const permissions = useAppSelector(
    (state: any) => state.persistReducers.login.permissions
  );
  const [data, setData] = useState([]);
  const [loadingAPI, setLoadingAPI] = useState<boolean>(false);
  const [errorAPI, setErrorAPI] = useState<boolean>(false);

  const fetchFraudSettings = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          APIConstants.getFraudDetection +
          `?module=receipts&feature=fraud_detect_configuration`
      );
      dispatch(
        receiptsActions.updateFraudSettings({
          receiptAmount: response.data?.result.receipt_amount,
          spendingAmount: response?.data?.result.spending_amount,
          multipleReceiptsStore: response?.data?.result.multiple_receipts_store,
          multipleReceiptsCalendar:
            response?.data?.result.multiple_receipts_calender,
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    receiptsList.length > 0 ? setLoadingAPI(false) : setLoadingAPI(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + APIConstants.receiptApi
      );
      const newData = response.data.value;
      const mData = newData.map((item: any) => {
        return {
          memberName: item.member_name ? item.member_name : "-",
          image: item.upload_log[0] ? item.upload_log[0].receipt_image : "-",
          loyaltyCardNo:
            item.loyalty_card_no === "" ? "-" : item.loyalty_card_no,
          amountBpo: item.amount_bpo ? item.amount_bpo : "-",
          amountMember: item.amount_member ? item.amount_member : "-",
          submissionDate: item.submission_date
            ? formatDate(item.submission_date)
            : "-",
          reviewedDate: item.reviewed_date
            ? item.reviewed_date === "1970-01-01T00:00:00.000Z"
              ? "-"
              : formatDate(item.reviewed_date)
            : "-",
          rejectionDate: item.upload_log
            ? item.upload_log.some(
                (log: any) =>
                  log.status === filterConstants.Reject.toLowerCase()
              )
              ? formatDate(
                  item.upload_log.find(
                    (log: any) =>
                      log.status === filterConstants.Reject.toLowerCase()
                  ).upload_time
                )
              : "-"
            : "-",

          tallyCheck: item.tally_check
            ? item.tally_check
              ? "Ok"
              : "Not Ok"
            : "-",
          tallyCheckMessage: item.tally_check_message
            ? item.tally_check_message === ""
              ? "-"
              : item.tally_check_message
            : "-",
          status: item.receipt_status ? item.receipt_status : "-",
          receiptType: item.receipt_type ? item.receipt_type : "-",
          navigateTo:
            item.id &&
            getFeaturePermissions(permissions, "Receipt", "Member Receipts")
              .update
              ? `${"/updateMemberReceipts/"}${item.id}`
              : null,
        };
      });
      dispatch(
        receiptsActions.updateReceiptsList({
          receiptsList: mData,
        })
      );
      setData(mData);

      setErrorAPI(false);
    } catch (error) {
      setErrorAPI(true);
    } finally {
      setLoadingAPI(false);
    }
  };
  return { fetchFraudSettings, fetchData, data, loadingAPI, errorAPI };
};
